import axios from 'axios';

export async function sendMail(data: any) {
  return await axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/common/contact/mxspace`, data);
}
